var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"all-div"},[_c('loading',{attrs:{"color":_vm.load_color,"active":true}}),_c('div',{staticClass:"load-text"},[_vm._v("กำลังโหลดดดด...")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }